import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import GenericExploreContent from '../../../Explore/GenericExploreContent/GenericExploreContent';
import { SectionHeadingTitle } from '../styles';
import { DailySelectionTool } from '../PersonalisedTodayScreen';

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
`;

const ToolsForYourDayContainer = styled.section``;

export interface ToolsForYourDayProps {
  tools: DailySelectionTool[];
  assetToken?: string | null;
}

const ToolsForYourDay = ({ tools, assetToken }: ToolsForYourDayProps) => {
  const { t: translate } = useTranslation('homepage');

  return (
    <ToolsForYourDayContainer>
      <HeadingWrapper>
        <SectionHeadingTitle>
          {translate('tools_for_your_day_section.title')}
        </SectionHeadingTitle>
      </HeadingWrapper>
      <GenericExploreContent
        content={tools}
        assetToken={assetToken}
        source="explore-tools-for-your-day"
      />
    </ToolsForYourDayContainer>
  );
};

export default ToolsForYourDay;
